/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import * as React from 'react';

import { ThemeMode } from '@vaisala/rockhopper-components';

type ThemeState = {
  theme: ThemeMode;
  toggleTheme: VoidFunction;
  setTheme: (theme: ThemeMode ) => void; // Add the correct type for 'theme' argument
};
export const ThemeContext = React.createContext<ThemeState>({
  theme: ThemeMode.Light,
} as ThemeState);

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const [theme, setTheme] = React.useState(ThemeMode.Light);
  const toggleTheme = () => setTheme(theme === ThemeMode.Light ? ThemeMode.Dark : ThemeMode.Light);

  return <ThemeContext.Provider value={{ theme, toggleTheme, setTheme }}>{children}</ThemeContext.Provider>;
};

export { useTheme } from './useTheme';
